import Backbone from 'backbone';
import React from 'react';

import ModelHubApp from 'model-hub/ModelHubApp';
import type {ModelHubRoute} from 'model-hub/modelHubRoutes';
import {renderReactElement} from 'util/RootReactRender';

class ModelHubRouter extends Backbone.Router {
  static initClass(): void {
    // One canonical URL per resource. The app runs Backbone.history.start({pushState: true}) (App.ts),
    // so these are real paths; {id} is the api_identifier (prd_/pbat_ style) consumed directly by the
    // detail hooks. The trailing query string is passed to handlers as an extra arg; pages that manage
    // their own query state read it from window.location.
    this.prototype.routes = {
      '': 'showModels',
      models: 'showModels',
      signup: 'showSignup',
      'new-prediction': 'showNewPrediction',
      predictions: 'showPredictions',
      'predictions/:id': 'showPredictionDetail',
      'prediction-batches': 'showBatches',
      'prediction-batches/:id': 'showBatchDetail',
      account: 'showAccount',
    };
  }

  renderRoute(route: ModelHubRoute): void {
    renderReactElement(<ModelHubApp route={route} />);
  }

  showModels(): void {
    this.renderRoute({kind: 'models'});
  }

  showSignup(): void {
    this.renderRoute({kind: 'signup'});
  }

  showNewPrediction(queryString?: string): void {
    const model = new URLSearchParams(queryString).get('model') || undefined;
    this.renderRoute(model == null ? {kind: 'new-prediction'} : {kind: 'new-prediction', model});
  }

  showPredictions(): void {
    this.renderRoute({kind: 'predictions'});
  }

  showPredictionDetail(id: string): void {
    this.renderRoute({kind: 'prediction-detail', id});
  }

  showBatches(): void {
    this.renderRoute({kind: 'batches'});
  }

  showBatchDetail(id: string): void {
    this.renderRoute({kind: 'batch-detail', id});
  }

  showAccount(): void {
    this.renderRoute({kind: 'account'});
  }
}
ModelHubRouter.initClass();

export default ModelHubRouter;
